export default "__VITE_ASSET__DA4Gu$vC__"